package io.horion.cv.models

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class CertificatState(
    val id: String,
    certificat: String = "",
    mois: String = "",
    annee: String = "",
    isOngoing: Boolean = false,
    description: String = ""
) {
    var certificat by mutableStateOf(certificat)
    var mois by mutableStateOf(mois)
    var annee by mutableStateOf(annee)
    var isOngoing by mutableStateOf(isOngoing)
    var description by mutableStateOf(description)
}